export const MOCK_RESPONSE_POST_ACCEPT_INVITATION = {};
export const MOCK_RESPONSE_GET_CONFIRM_TOKEN = { organizationId: 'mock-org-id' };
